import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseThisPlan: {
    id: 'view.choosePricing.planPreview.chooseThisPlan',
    defaultMessage: 'Choose this plan',
  },
  contactSales: {
    id: 'view.choosePricing.planPreview.contactSales',
    defaultMessage: 'Contact sales',
  },
  addContract: {
    id: 'view.choosePricing.planPreview.addContract',
    defaultMessage: 'Add contract',
  },
  setPlanSuccess: {
    id: 'view.choosePricing.planPreview.setPlanSuccess',
    defaultMessage: 'Plan set successfully',
  },
  setPlanError: {
    id: 'view.choosePricing.planPreview.setPlanError',
    defaultMessage: 'Error setting plan',
  },
  freePlan: {
    id: 'view.choosePricing.planPreview.freePlan',
    defaultMessage: 'Free plan',
  },
  isActivePlan: {
    id: 'view.choosePricing.planPreview.isActivePlan',
    defaultMessage: 'Active',
  },
  activateFreePricingPlanSuccess: {
    id: 'view.choosePricing.planPreview.activateFreePricingPlanSuccess',
    defaultMessage: 'Free pricing plan activated successfully',
  },
  activateFreePricingPlanError: {
    id: 'view.choosePricing.planPreview.activateFreePricingPlanError',
    defaultMessage: 'Error activating free pricing plan',
  },
});
